"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _utils = require("../../utils/utils");
require("../../utils/_variables.css");
// Packages

// Components

// Utils

// Styles

const {
  canHover
} = (0, _utils.getMediaQueries)();
const Link = _styledComponents.default.a.withConfig({
  displayName: "standalone__Link",
  componentId: "sc-crk6ha-0"
})(["--marginLeft:10px;background:transparent;color:", ";display:flex;padding:0 8px;max-width:100%;text-decoration:none;cursor:pointer;transition:all 0.3s ease-in-out;.text{color:", ";font-size:20px;line-height:28px;font-weight:400;}svg{margin-left:var(--marginLeft);path{stroke:", ";}transition:all 0.3s ease-in-out;}", ""], props => props.$defaultColor || _utils.colors["pilot-grey-7"].hex, props => props.$defaultColor || _utils.colors["pilot-grey-7"].hex, props => props.$defaultColor || _utils.colors["pilot-grey-7"].hex, canHover`
    &:hover {
      
      text-decoration: none;
      svg {
        margin-left: calc(var(--marginLeft) + 8px);
        path {
          stroke: ${props => props.$activeColor || _utils.colors["pacific-blue"].hex};
        }
      }
      .text {
        color: ${props => props.$activeColor || _utils.colors["pacific-blue"].hex};
      }
    }
  `);
const LinkContentsContainer = _styledComponents.default.div.withConfig({
  displayName: "standalone__LinkContentsContainer",
  componentId: "sc-crk6ha-1"
})(["align-items:center;display:flex;justify-content:center;margin:0 auto;"]);
function StandaloneLink(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Link, Object.assign({}, props.linkAttributes, {
    $activeColor: props.activeColor,
    $defaultColor: props.defaultColor,
    as: props.linkAttributes && props.linkAttributes.href ? "a" : _gatsby.Link,
    className: props.className
  }), /*#__PURE__*/_react.default.createElement(LinkContentsContainer, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "text"
  }, props.linkText), props.image && props.image, props.icon && props.icon)));
}
StandaloneLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StandaloneLink",
  "props": {
    "activeColor": {
      "description": "Text color of link when link is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "linkText": {
      "description": "Link text",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "defaultColor": {
      "description": "Default text color of link",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "image": {
      "description": "Image should be a Generic Icon",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "icon": {
      "description": "Button icon (should be GenericIcon)",
      "type": {
        "name": "element"
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "className": {
      "description": "Class name of link",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = StandaloneLink;
exports.default = _default;
StandaloneLink.propTypes = {
  /**
   * Text color of link when link is active (clicked / hovered / pressed)
   */
  activeColor: _propTypes.default.string,
  /**
   * Link text
   */
  linkText: _propTypes.default.string.isRequired,
  /**
   * Default text color of link
   */
  defaultColor: _propTypes.default.string,
  /**
   * Image should be a Generic Icon
   */
  image: _propTypes.default.element,
  /**
   * Button icon (should be GenericIcon)
   */
  icon: _propTypes.default.element,
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape(),
  /** Class name of link */
  className: _propTypes.default.string
};